module.exports = __webpack_public_path__ + "static/media/bin.4ad381c3.png";